import { ChangeDetectorRef, Component, ElementRef, HostListener, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { WebsocketService } from '../../services/websocket.service';
import { InvitationService } from '../../services/invitation.service';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit {

  message: string | null = null;
  sub!: Subscription;
  receiverId = '';
  responseMessage = '';
  status = 'PENDING';
  loginUser: any;
  notificationId: any;
  notificationsList: any[] = [];
  unreadMessageCount: any = 0;
  isOpen = false;
  previousNotifications: any[] = [];
  USE_DUMMY = true;
  businessAccountId : any

  constructor(private wsService: WebsocketService, private invitationService: InvitationService,
    private el: ElementRef,
    private cdr: ChangeDetectorRef,
  ) { }

  @HostListener('document:click')
  closeOnOutside() { if (this.isOpen) this.isOpen = false; }

  ngOnInit() {
    console.log('NotificationComponent initialized');

    // Seed demo data only if API not ready OR nothing came in
    if (this.USE_DUMMY && (!this.notificationsList || this.notificationsList.length === 0)) {
      this.notificationsList = [
        {
          id: 101,
          senderUsername: 'Melissa Maker',
          message: 'assigned you as "Sales Rep" of "Malibu Nails" on "Sales CRM"',
          status: 'UNREAD',
          type: 'task',
          when: '8h',
          showAccept: true
        },
        {
          id: 102,
          senderUsername: 'Leslie Link',
          message: 'set a reminder for you to contact "Casey of Casey Cosmetics" in "1 Week"',
          status: 'UNREAD',
          type: 'reminder',
          when: '10h',
          showAccept: false
        },
        {
          id: 103,
          senderUsername: 'Mark Maron',
          message: 'assigned you as "Sales Rep" of "Clayton Care" on "Sales CRM"',
          status: 'UNREAD',
          type: 'task',
          when: '16h',
          showAccept: true
        },
        {
          id: 104,
          senderUsername: 'Sarah Simpson',
          message: 'assigned you as "Sales Rep" of "Everlane" on "Sales CRM"',
          status: 'UNREAD',
          type: 'task',
          when: '1d',
          showAccept: true
        }
      ];

      this.previousNotifications = [
        {
          id: 201,
          senderUsername: 'Morgan May',
          message: 'set a reminder for you to contact "Amber Avery" of "Pixel Studio" in "1 Week"',
          status: 'READ',
          when: 'Yesterday'
        },
        {
          id: 202,
          senderUsername: 'Karen Dominguez',
          message: 'set a reminder for you to contact "Lloyd Marsh" in "1 Week"',
          status: 'READ',
          when: 'Yesterday'
        }
      ];

      this.unreadMessageCount = this.notificationsList.filter(n => n.status !== 'READ').length;
    }

    this.loginUser = localStorage.getItem('loginUser') ? JSON.parse(localStorage.getItem('loginUser') || '{}') : null;
    console.log('Logged in user:', this.loginUser);
    this.wsService.connect(this.loginUser.id);

    this.fetchUnreadCount(this.businessAccountId);
    // this.sub = this.wsService.isStompConnected$.subscribe(
    //   (connectedUserId) => {
    //     if (connectedUserId) {
    //       this.fetchUnreadNotifications(connectedUserId);
    //     }
    //   }
    // );

    this.sub = this.wsService.notifications$.subscribe((payload: any) => {
      console.log('NotificationComponent received payload:', payload);
      if (payload != null) {
        this.notificationsList.push(payload);
        if (payload.message) {
          setTimeout(() => payload.message = null, 10000);
        }
        if (payload.id != null) {
          this.readedNotification(payload.id);
        }
      }
    });
  }

  fetchUnreadNotifications(userId: string): void {
    console.log('Fetching unread notifications for userId:', userId);
    this.invitationService.fetchUnread(Number(userId)).subscribe({
      next: (notifications) => {
        console.log('Unread notifications:', notifications);
        // Logic to merge these historical notifications with your current list
      },
      error: (err) => {
        console.error('Error fetching unread notifications:', err);
      },
    });
  }

  fetchUnreadCount(userId: string): void {
    console.log('Fetching unread notifications for userId:', userId);
    this.invitationService.fetchUnreadCount(Number(userId)).subscribe({
      next: (notifications) => {
        console.log('Unread notifications:', notifications);
        this.unreadMessageCount = notifications;
      },
      error: (err) => {
        console.error('Error fetching unread notifications:', err);
      },
    });
  }

  private readedNotification(userId: string): void {
    console.log('Fetching unread notifications for userId:', userId);
    this.invitationService.markAsRead(Number(userId)).subscribe({
      next: (notifications) => {
        console.log('Unread notifications:', notifications);
        // Logic to merge these historical notifications with your current list
      },
      error: (err) => {
        console.error('Error fetching unread notifications:', err);
      },
    });
  }

  // ngAfterViewInit() {
  //   console.log('Fetching unread notifications for userId:', this.userId);
  //   this.invitationService.fetchUnread(Number(this.userId)).subscribe({
  //     next: notifications => {
  //       console.log('Unread notifications:', notifications);
  //     },
  //     error: err => {
  //       console.error('Error fetching unread notifications:', err);
  //     }
  //   });
  // }

  ngOnDestroy() {
    if (this.sub) this.sub.unsubscribe();
    this.wsService.disconnect();
  }

  // sendInvitation() {
  //   const invitation = {
  //     //"senderUserId": this.businessId,
  //     "receiverUserId": this.loginUser.id == 1 ? 92 : 1,
  //     "senderUsername": this.loginUser.id == 1 ? "krishna" : "diya",
  //     "receiverUsername": this.loginUser.id == 1 ? "diya" : "krishna",
  //   };
  //   this.invitationService.sendInvitation(invitation).subscribe({
  //     next: res => this.responseMessage = res,
  //     error: err => this.responseMessage = '❌ Error sending invitation'
  //   });
  // }

  acceptInvitation(notification: any): void {
    const invitation = {
      "id": notification.id,
      "senderUsername": this.loginUser.id == 92 ? "diya" : "krishna",
      "receiverUsername": this.loginUser.id == 92 ? "krishna" : "diya",
      "senderUserId": this.loginUser.id,
      "receiverUserId": this.loginUser.id == 92 ? 1 : 92,
    };
    this.invitationService.acceptInvitation(invitation).subscribe({
      next: res => {
        console.log(res);
        this.message = null; // clear notification
        this.notificationsList
          .find(n => n.id == notification.id) // 1. Find the object reference
          .message = null;
      },
      error: err => console.error('Error accepting:', err)
    });
  }

  markAsRead(n: any, ev?: Event) {
    if (ev) ev.stopPropagation();
    if (!n || n.status === 'READ') return;

    n.status = 'READ';
    this.unreadMessageCount = Math.max(
      0,
      this.unreadMessageCount - 1
    );

    // call your existing API hook
    if (n.id != null) this.readedNotification(n.id);
  }

  // Remove from "previous"
  remove(n: any) {
    this.previousNotifications = this.previousNotifications.filter(x => x.id !== n.id);
  }

  // Clear all visible
  clearAll(ev?: Event) {
    if (ev) ev.stopPropagation();
    this.notificationsList = [];
    this.previousNotifications = [];
    this.unreadMessageCount = 0;
  }

  open(): void {
    if (!this.isOpen) {
      this.isOpen = true;
      this.cdr.markForCheck();
    }
  }

  close(): void {
    if (this.isOpen) {
      this.isOpen = false;
      this.cdr.markForCheck();
    }
  }

  /** Close when clicking anywhere outside the notification panel/component */
  @HostListener('document:click', ['$event'])
  onGlobalClick(ev: MouseEvent): void {
    const clickedInside = this.el.nativeElement.contains(ev.target as Node);
    if (!clickedInside) {
      this.close();
    }
  }

  /** Close on ESC key */
  @HostListener('document:keydown.escape', ['$event'])
  onEsc(): void {
    this.close();
  }

 toggle(ev?: Event): void {
    if (ev) ev.stopPropagation();     // <- important so doc click doesn’t fire
    this.isOpen = !this.isOpen;
    this.cdr.markForCheck();
  }
}
